import { Fragment } from 'react';

import { Td } from '../../summary/components/Td.js';
import { Tr } from '../../summary/components/Tr.js';
import { Typography } from '../../summary/components/Typography.js';
import { SummaryTableExtraCells } from './SummaryTableExtraCells.js';
import { COMPS_PER_TABLE } from './constants.js';

export const SummaryHeaderRow = ({
  sequence,
  firstColumnHeader,
  suppressTopBorder,
}: {
  sequence: string[];
  firstColumnHeader?: string;
  suppressTopBorder?: boolean;
}) => {
  return (
    <Tr>
      <Td width="16%" isFirstColumn={true} isFirstRow={!suppressTopBorder}>
        {firstColumnHeader ?? ''}
      </Td>
      <Td width="12%" isFirstRow={!suppressTopBorder}>
        <Typography variant="h5">Feature</Typography>
      </Td>
      {sequence.map((compId, idx) => (
        <Fragment key={`${compId}-${idx}`}>
          <Td width="12%" isFirstRow={!suppressTopBorder}>
            <Typography variant="h5">Feature</Typography>
          </Td>
          <Td key={`${compId}-${idx}`} width="12%" isFirstRow={!suppressTopBorder}>
            <Typography variant="h5">Adjustment</Typography>
          </Td>
        </Fragment>
      ))}
      <SummaryTableExtraCells
        count={COMPS_PER_TABLE - sequence.length}
        span={2}
        isFirstRow={true}
      />
    </Tr>
  );
};
